import React from 'react';
// import { useMatomo } from '@datapunt/matomo-tracker-react'
// import { clsx } from 'clsx';

'use strict';

function RundedrehenMapListItemPlacePopup({item}) {
  // const { trackEvent } = useMatomo();

  return <div className="
    px-2 py-2
    md:px-4 md:py-3
    bg-neutral_d rounded-md
  ">

    <div className="
      text-primary text-tiny md:text-base
      font-bold pb-1
    ">
      {item.city}
    </div>

    <div className="
      map-popup-item
    ">

      <div className="
        min-w-0
        relative
        font-bold text-base md:text-md
        text-white
      ">
        {item.url && <a
          href={item.url}
          target="_blank"
          rel="nofollow"
          // onClick={(e) => {
          //   trackEvent({ category: 'places', action: 'click outbound link', name: item.type + ' ' + item.category + ' ' + item.label, value: item.id });
          // }}
        className="
          block
          link-bigtarget
          text-white hover:text-yellow-neon
        ">
          {item.label}
        </a>}

        {!item.url && <span
        className="
          block
        ">
          {item.label}
        </span>}

        {item.popup_meta && <p className="
          text-sm md:text-tiny text-primary tracking-wide
          nowrap overflow-hidden text-ellipsis
          mt-1 md:mt-2
        " title={item.popup_meta}>
          {item.popup_meta}
        </p>}
      </div>
    </div>
  </div>

}

export default RundedrehenMapListItemPlacePopup;
